import type {
  CreateDevicePayload,
  UpdateDevicePayload,
} from '../types/device.types'

// Matches the backend Device.name column; station_label allows 255.
export const DEVICE_NAME_MAX_LENGTH = 50

const graphemeSegmenter = new Intl.Segmenter(undefined, {
  granularity: 'grapheme',
})

// The backend counts code points; cut on grapheme boundaries so emoji aren't split.
function truncateDeviceName(name: string) {
  let truncated = ''
  let codePointCount = 0
  for (const { segment } of graphemeSegmenter.segment(name)) {
    const segmentLength = Array.from(segment).length
    if (codePointCount + segmentLength > DEVICE_NAME_MAX_LENGTH) break
    truncated += segment
    codePointCount += segmentLength
  }
  return truncated.trimEnd()
}

export function mapDeviceWritePayload(
  payload: CreateDevicePayload | UpdateDevicePayload,
  options?: { isCreate?: boolean },
) {
  const mapped: Record<string, unknown> = { ...payload }

  if ('assigned_user_id' in mapped) {
    mapped.assigned_user = mapped.assigned_user_id
    delete mapped.assigned_user_id
  }

  if (mapped.station_label && !mapped.name) {
    mapped.name = mapped.station_label
  }

  if (typeof mapped.name === 'string') {
    mapped.name = truncateDeviceName(mapped.name)
  }

  // Device create/update only persists `wifi_enabled`. Customer WiFi credentials
  // live on a separate DeviceWifiNetwork row via
  // `GET|POST|PUT|DELETE .../devices/{id}/wifi-settings/` (ssid / password / mode).
  // Admin 2 does not call that endpoint yet — keep stripping so we don't pretend
  // these fields are saved on the device write path (see VOI-428 follow-up).
  delete mapped.primary_extension_id
  delete mapped.line_button_count
  delete mapped.wifi_network_ssid
  delete mapped.wifi_security_mode
  delete mapped.wifi_password

  if (options?.isCreate) {
    if (mapped.has_new_config === undefined) {
      mapped.has_new_config = true
    }
    if (mapped.pages === undefined || mapped.pages === '') {
      mapped.pages = 0
    }
  }

  return mapped
}
